/**
 * PendingUploadCard – shows a preview image with spinner overlay
 * while a gallery upload is in progress.
 */

import { Loader2 } from 'lucide-react';

interface PendingUploadCardProps {
  previewUrl: string;
}

export function PendingUploadCard({ previewUrl }: PendingUploadCardProps) {
  return (
    <div className="relative aspect-square rounded-lg overflow-hidden bg-muted">
      <img
        src={previewUrl}
        alt="Laddar upp…"
        className="w-full h-full object-cover opacity-60"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-background/30 backdrop-blur-[1px]">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-[11px] font-medium text-foreground/80">
          Laddar upp…
        </span>
      </div>
    </div>
  );
}
